/**
 * How this package reports that something is wrong.
 *
 * Two severities, and the distinction is load-bearing rather than cosmetic.
 * H7 settled that the rota shows coverage and does not police it, and the
 * Delivery Plan says double-booking and travel-time checks are "warnings, not
 * blocks". The same instinct applies to configuration: an organiser who is
 * halfway through building a course has a course that is not yet valid, and
 * refusing to save it would fight the way the work is actually done.
 *
 * So `error` means the data is self-contradictory and cannot be stored.
 * `warning` means it is storable and a human should look at it.
 *
 * Deliberately not an exception. Validation here runs over a whole form or a
 * whole course and reports everything at once; throwing on the first problem
 * would make an operator fix a list of six things one reload at a time.
 */
export function problem(field, severity, message) {
    return { field, severity, message };
}
/** True when nothing blocks storage. Warnings are not blocking, by design. */
export function isStorable(problems) {
    return !problems.some((p) => p.severity === 'error');
}
export function errors(problems) {
    return problems.filter((p) => p.severity === 'error');
}
export function warnings(problems) {
    return problems.filter((p) => p.severity === 'warning');
}
/** A non-empty string once trimmed. Whitespace-only names are a common paste error. */
export function isFilled(value) {
    return value.trim().length > 0;
}
/** A whole number at or above `min`. Rejects NaN, Infinity and fractions. */
export function isWholeNumberAtLeast(value, min) {
    return Number.isInteger(value) && value >= min;
}
//# sourceMappingURL=validation.js.map